import { Grid } from "@mui/material";
import { TextInput, required } from "react-admin";
import { nameLatinRegexValidator } from "utils/validations";

const NamesEnSection = () => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={4}>
      <TextInput
        source="firstNameEn"
        label="Име (латиница)"
        validate={[required("Задължително"), nameLatinRegexValidator]}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput source="secondNameEn" label="Презиме (латиница)" validate={nameLatinRegexValidator} fullWidth />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="lastNameEn"
        label="Фамилия (латиница)"
        validate={[required("Задължително"), nameLatinRegexValidator]}
        fullWidth
      />
    </Grid>
  </Grid>
);

export default NamesEnSection;
